import JackProfile from '@assets/images/JackProfile.png';
import WilliamProfile from '@assets/images/WilliamProfile.png';
// import IrvinProfile from '@assets/images/IrvinProfile.png';

export const TeamMembers = [
  {
    name: 'Jack Cheung',
    detail: 'Business & Growth',
    title: 'CEO & Co-Founder',
    imageFile: JackProfile,
    linkedInUrl: 'https://www.linkedin.com/in/hinlokcheung',
  },
  {
    name: 'William Lo',
    detail: 'Technology & Operations',
    title: 'CTO & Co-Founder',
    imageFile: WilliamProfile,
    linkedInUrl: 'https://www.linkedin.com/in/williamlohk',
  },
  // {
  //   name: 'Irvin Ives Lau',
  //   detail: 'Technology & Operations',
  //   title: 'Lead Engineer',
  //   imageFile: IrvinProfile,
  //   linkedInUrl: 'https://www.linkedin.com/in/lauirvin/',
  // },
];

export default TeamMembers;
